import { render, staticRenderFns } from "./SingleTableGroupingComponent.vue?vue&type=template&id=90718474&scoped=true"
import script from "./SingleTableGroupingComponent.vue?vue&type=script&lang=js"
export * from "./SingleTableGroupingComponent.vue?vue&type=script&lang=js"
import style0 from "./SingleTableGroupingComponent.vue?vue&type=style&index=0&id=90718474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90718474",
  null
  
)

export default component.exports